import { SALARY_RAW_CHARGED_FIELD } from 'routes/HumanResourcesModule/business/definitions';
import { PayStateIndicatorItem } from './types';
import { EChartsOption } from 'echarts';
import { FULL_MONTHS } from 'helpers/dateHelper';
export function getBarLineEchartOptions(
    colors: string[],
    currentExercice: number,
    data: PayStateIndicatorItem[],
): EChartsOption {
    const previousYearData = new Array(12).fill(null);
    const currentYearData = new Array(12).fill(null);

    Object.values(data).forEach((value: PayStateIndicatorItem) => {
        const { date: rawDate, [SALARY_RAW_CHARGED_FIELD]: salary } = value;
        const year = new Date(rawDate).getFullYear();
        const monthIndex = new Date(value['date']).getMonth();

        if (year === currentExercice) {
            currentYearData[monthIndex] = salary as number;
        } else if (year === currentExercice - 1) {
            previousYearData[monthIndex] = salary as number;
        }
    });

    Object.values(data)
        .filter((value: PayStateIndicatorItem) => {
            const date = new Date(value['date']);
            return date.getFullYear() === currentExercice;
        })
        .forEach((value: PayStateIndicatorItem) => {
            const monthIndex = new Date(value['date']).getMonth();
            currentYearData[monthIndex] = value[
                SALARY_RAW_CHARGED_FIELD
            ] as number;
        });
    return {
        color: colors,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                label: {
                    formatter: (params) => {
                        const { seriesData } = params;
                        return FULL_MONTHS[seriesData?.[0]?.dataIndex ?? 0];
                    },
                },
            },
        },
        grid: {
            right: '20%',
        },
        legend: {
            data: [
                (currentExercice - 1).toString(),
                currentExercice.toString(),
            ],
        },
        xAxis: [
            {
                type: 'category',
                axisTick: {
                    alignWithLabel: true,
                },
                data: [
                    'J',
                    'F',
                    'M',
                    'A',
                    'M',
                    'J',
                    'J',
                    'A',
                    'S',
                    'O',
                    'N',
                    'D',
                ],
            },
        ],
        yAxis: [
            {
                show: false,
            },
        ],
        series: [
            {
                name: (currentExercice - 1).toString(),
                type: 'bar',
                itemStyle: {
                    borderRadius: 10,
                },
                data: previousYearData,
            },
            {
                name: currentExercice.toString(),
                type: 'line',
                data: currentYearData,
            },
        ],
    };
}
